import { createSlice } from '@reduxjs/toolkit';
import { AccountState } from './type';

const initialState: AccountState = {
  isLoading: false,
  isSuccess: false,
  error: {
    username: null,
    password: null,
    email: null,
    stripePaymentLinkId: null,
  },
};

const accountSlice = createSlice({
  name: 'auth/account',
  initialState,
  reducers: {
    isAccountLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    isAccountSuccess: state => {
      state.isSuccess = true;
    },
    isAccountError: (state, action) => {
      state.isSuccess = false;
      state.error = action.payload;
    },
  },
});

export const { isAccountSuccess, isAccountError, isAccountLoading } = accountSlice.actions;

export default accountSlice.reducer;
